export default __webpack_public_path__ + "static/media/intro-logo.c3f03c7a.png";